<div class="notification-container">
  <div
    *ngFor="let notification of notifications"
    class="notification"
    [class.notification-success]="notification.type === 'success'"
    [class.notification-error]="notification.type === 'error'"
    [class.notification-info]="notification.type === 'info'"
    [class.notification-removing]="notification.isRemoving"
  >
    <div class="notification-content">
      <span class="notification-text">{{ notification.text }}</span>
      <button
        class="notification-close"
        (click)="removeNotification(notification.id)"
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  </div>
</div>
